import { Pipe, PipeTransform } from '@angular/core';
import { Vehicle } from '@quorum/models/xs-resource';
@Pipe({
  name: 'addFreeformMatchingScoreToVehicles',
})
export class AddFreeformMatchingScoreToVehiclesPipe implements PipeTransform {
  transform(vehicles: Vehicle[], vehicleFreeformName: string): any {
    let vehiclesWithScore: { vehicle: Vehicle; metaData: { freeFormScore: number } }[] = [];

    let vehicleFreeformNameArr = vehicleFreeformName
      ? vehicleFreeformName
          .toLowerCase()
          .split(' ')
          .filter((item) => item)
      : [];

    let vehiclesCopy = vehicles.map((vehicle: any) => {
      return (vehicle = { vehicle: vehicle, metaData: { freeFormScore: 0 } });
    });

    vehiclesCopy.map((vehicleObj) => {
      for (let i = 0; i < vehicleFreeformNameArr.length; i++) {
        if (
          vehicleObj.vehicle.model.toLowerCase().includes(vehicleFreeformNameArr[i]) ||
          vehicleObj.vehicle.make.toLowerCase().includes(vehicleFreeformNameArr[i]) ||
          parseInt(vehicleObj.vehicle.year) == parseInt(vehicleFreeformNameArr[i])
        ) {
          vehicleObj.metaData.freeFormScore += 1;
        }
      }
      vehiclesWithScore.push(vehicleObj);
    });

    return vehiclesWithScore ? vehiclesWithScore : vehiclesCopy;
  }
}
